module.exports = __webpack_public_path__ + "img/logos.c3087b11.jpg";